<section class="print-all-score-details-container">
  <zbp-modal-template
    [bodyContent]="printAllModalBody"
    [isScrollable]="true"
  >
    <ng-template #printAllModalBody>
      @for (vm of studentViewModels; track vm.studentName) {
        <div class="score-detail-page">
          <zbp-score-detail-view
            [studentName]="vm.studentName"
            [className]="vm.className"
            [productName]="vm.productName"
            [activityName]="vm.activityName"
            [columns]="vm.columns"
            [rows]="vm.rows"
            [printableHeaders]="vm.printableHeaders"
            [showSpinner]="false"
          />
        </div>
      }
    </ng-template>
  </zbp-modal-template>
</section>
